import React from 'react';
import ReactDOM from "react-dom"
import { Container } from "@material-ui/core";
import { useLocation } from 'react-router-dom';
import { getPublicIp } from '../../utils/index';
import { captureOrderPaypal, createOrderPaypal, registerPayPalPayment } from '../../services/Payment';

const PayPalButtonApp2 = window.paypal.Buttons.driver("react", { React, ReactDOM });

const PayPalButton = (props) => {
  const location = useLocation();

  const datainvoice = {
    userid: props.invoice.client_id,
    currency: 0,
    gateway: props.paymethod,
    description: 'Invoice Payment',
    amountin: props.invoice.total,
    invoiceid: props.invoice.invoiceid,
    currencyid: props.invoice.currencyid,
  }

  const invoiceid = props.invoice.invoiceid;

  const createOrder2 = async (data, actions) => {
    const datasend = {
      value: props.invoice.total,
      description: `Neothek - Nota Nro. ${invoiceid}`,
      invoiceid: invoiceid,
      currencycode: props.invoice.currencycode,
      currencyid: props.invoice.currencyid,
    }
    const order = await createOrderPaypal(datasend);
    let orderid = null;
    
    //console.log('order', order);

    if(order.error === false){
      orderid = order.id
    }

    return orderid
  }

  const onApprove2 = async (data, actions) => {
    //console.log('data on aprrove2', data);
    const capture = await captureOrderPaypal(data.orderID);
    //console.log('capture', capture);

    if(capture.error === false){
      if(capture.status === 'COMPLETED'){
        datainvoice['ipclient'] = await getPublicIp();
        const infopay = {
          datainvoice: datainvoice,
          datagateway: capture
        } 
        const paydout = await registerPayPalPayment(infopay);
  
        if(paydout.error === false){
          window.open(location.pathname, "_self");
        }
        
      }
    }else{
      alert(`Error: ${capture.name} \n  ${capture.message} \n  Please contact support`);
    }

    //return capture;

  }


  return (

    <Container>
      <PayPalButtonApp2
        createOrder={(data, actions) => createOrder2(data, actions)}
        onApprove={(data, actions) => onApprove2(data, actions)}
      />
    </Container>


  );
};

export default PayPalButton;